import { render, staticRenderFns } from "./scrollMenu.vue?vue&type=template&id=6dad0c8e&scoped=true&"
import script from "./scrollMenu.vue?vue&type=script&lang=js&"
export * from "./scrollMenu.vue?vue&type=script&lang=js&"
import style0 from "./scrollMenu.vue?vue&type=style&index=0&id=6dad0c8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dad0c8e",
  null
  
)

export default component.exports